import React, { Fragment, useState, useEffect } from 'react';
import CSVReader from 'react-csv-reader';
import { Form } from '@contently/toolkit';

import { get, post } from '../../../../utils/shared/api';
import { validateCsv, renderPluralized, renderStoriesByTagType } from './csv_helpers';

import ExampleCsv from './example_csv';
import PreviewCsv from './preview_csv';
import ConfirmationModal from './confirmation_modal';

const BulkStoryTaggingContainer = (props) => {
  const { appData } = props;
  const { brandProfileId } = JSON.parse(appData);
  const [parsedCsvData, setParsedCsvData] = useState(null);
  const [publicationStories, setPublicationStories] = useState(null);
  const [publicationTags, setPublicationTags] = useState(null);
  const [fetching, setFetching] = useState(true);
  const [posted, setPosted] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const fetchData = async () => {
    setFetching(true);
    const storiesRequest = get(
      `/api/v1/brand_profiles/${brandProfileId}/stories?include=tags.tag_group`
    );
    const tagsRequest = get(
      `/api/v1/brand_profiles/${brandProfileId}/tags`
    );

    return Promise.all([
      storiesRequest,
      tagsRequest
    ]).then((values) => {
      setPublicationStories(values[0]);
      setPublicationTags(values[1]);
      setFetching(false);
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleConfirmClick = () => {
    post(
      `/api/v1/brand_profiles/${brandProfileId}/bulk_tag_stories`,
      JSON.stringify(
        { csv_data: parsedCsvData }
      )
    ).then(() => {
      setPosted(true);
      setModalIsOpen(false);
    });
  };

  const handleFileLoaded = (data) => {
    const parsedCsv = validateCsv(data, publicationStories, publicationTags);
    setParsedCsvData(parsedCsv);
  };

  const handleAddTagsClick = () => {
    setModalIsOpen(true);
  };

  const handleCancelClick = () => {
    setModalIsOpen(false);
  };

  const handleCsvButtonClick = () => {
    setParsedCsvData(null);
    setPosted(false);
    fetchData();
  };

  let buttons = null;
  if (parsedCsvData && parsedCsvData.totalTagsToAdd > 0) {
    buttons = (
      <Fragment>
        {
          !posted && (
            <Form.Button
              onClick={handleAddTagsClick}
              variant="primary"
            >
              Add Tags
            </Form.Button>
          )
        }
        <Form.Button
          variant="secondary"
          onClick={handleCsvButtonClick}
        >
          Upload another CSV
        </Form.Button>
      </Fragment>
    );
  }

  let csvReader = null;
  if (fetching) {
    csvReader = (
      <span>
        loading...
      </span>
    );
  }
  if ((!fetching && !parsedCsvData) || (parsedCsvData && parsedCsvData.invalidMessage)) {
    csvReader = (
      <CSVReader
        onFileLoaded={handleFileLoaded}
        parserOptions={{ header: true, skipEmptyLines: true }}
      />
    );
  }

  let header = null;
  let preview = null;
  let exampleCsv = (
    <ExampleCsv
      headers={['Title', 'Id', 'Tag Group 1', 'Tag Group 2']}
      rows={[
        ['How to Upload Stuff!', '23145', 'Example Tag Name 1, Another Example Tag Name 1', 'Example Tag Name 2, Another Example Tag Name 2']
      ]}
    />
  );
  if (parsedCsvData && parsedCsvData.validStories) {
    header = <h1>Preview</h1>;
    preview = (
      <PreviewCsv
        parsedCsvData={parsedCsvData}
      />
    );
    exampleCsv = null;
  }
  if (posted) {
    const copy = `Success! You have added ${renderPluralized('tag', parsedCsvData.totalTagsToAdd)} to ${renderStoriesByTagType(parsedCsvData.validStories, 'tagsToAdd')}`;
    header = (
      <h1>
        {copy}
      </h1>
    );
  }

  let error = null;
  if (parsedCsvData && parsedCsvData.invalidMessage) {
    error = (
      <span style={{ color: 'red' }}>
        {parsedCsvData.invalidMessage}
      </span>
    );
  }

  let modal = null;
  if (parsedCsvData && !parsedCsvData.invalidMessage) {
    modal = (
      <ConfirmationModal
        csvData={parsedCsvData}
        isOpen={modalIsOpen}
        onCancel={() => { handleCancelClick(); }}
        onConfirm={() => { handleConfirmClick(); }}
      />
    );
  }

  return (
    <div>
      <div className="ui bottom attached active tab segment" style={{ borderTop: 'none' }}>
        <h2 className="ui dividing header">
          Bulk Story Tagging
        </h2>
        {header}
        {exampleCsv}
        {preview}
        {error}
        <div className="divider row actions">
          {buttons}
          {csvReader}
        </div>
      </div>
      {modal}
    </div>
  );
};

export default BulkStoryTaggingContainer;



// WEBPACK FOOTER //
// ./app/javascript/app/components/admin2/bulk_story_tagging/bulk_story_tagging_container.jsx